import React, { useContext, useState } from 'react';

import useTranslate from '../../../../../common/hooks/useTranslate';

import FilterCtx from '../../../../../context/filterContext/filterCtx';

import DocNameFilter from '../../../../ui/filters/docNameFilter/docNameFilter';
import FundsFilter from '../../../../ui/filters/fundsFilter/fundsFilter';
import InvestorsFilter from '../../../../ui/filters/investorsFilter/investorsFilter';
import ClassificationsFilter from '../../../../ui/filters/classificationsFilter/classificationsFilter';
import ActivityFeedPeriodFilter from '../../../../ui/filters/activityFeedPeriodFilter/activityFeedPeriodFilter';
import TypePickerFilter from '../../../../ui/filters/typePickerFilter/typePickerFilter';

import '@progress/kendo-theme-default/dist/all.css';
import '../../../../ui/table/table.scss';
import '../../../../../common/styles/globalClasses.scss';
import '../../../../ui/filters/filters.scss';
import './activityTableFilters.scss';

const ActivityTableFilters: React.FC = () => {
  const [doRerender, setDoRerender] = useState<boolean>(true);
  const [uniqueKey, setUniqueKey] = useState<string>('');

  const { t } = useTranslate();
  const filterCtx = useContext(FilterCtx);

  const resetFilters = () => {
    const date = new Date();
    setUniqueKey(date.toString());
    filterCtx.clearFiltersActivity();
    setDoRerender(!doRerender);
  };

  return (
    <>
      <div className='filters'>
        <div className='filters-group'>
          <TypePickerFilter className='hidden-mobile' />
          <DocNameFilter
            //@ts-ignore - Not able to fix this
            key={!doRerender}
            className='hidden-mobile'
            table='activity'
          />
          <div className='type-search-filters hidden-desktop'>
            <TypePickerFilter />
            <DocNameFilter
              //@ts-ignore - Not able to fix this
              key={!doRerender}
              table='activity'
            />
          </div>
          <ActivityFeedPeriodFilter key={uniqueKey + 4} />
        </div>
        <div className='filters-multiselect hidden-mobile'>
          <ClassificationsFilter key={uniqueKey + 3} table='activity' />
          <FundsFilter key={uniqueKey + 1} table='activity' />
          <InvestorsFilter key={uniqueKey + 2} table='activity' />
        </div>
        <button type='button' className='filter-button reset' disabled={!filterCtx.hasActivityFilters()}
                onClick={resetFilters}>
          {t('FILTERS.BUTTON_RESET')}
        </button>
      </div>
    </>
  );
};

export default ActivityTableFilters;
